import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getProductById, getCategoryBySlug } from '../data/productsData';
import './ProductDetail.css';

const ProductDetail = () => {
  const { category, productId } = useParams();
  const navigate = useNavigate();
  const product = getProductById(productId);
  const categoryData = getCategoryBySlug(category);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [productId]);

  if (!product || product.category !== category) {
    return (
      <div className="product-not-found">
        <h2>Product not found</h2>
        <div className="not-found-actions">
          <button onClick={() => navigate(-1)} className="back-btn">Go Back</button>
          <Link to="/" className="home-btn">Go Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="product-detail-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="breadcrumb-container">
          <Link to="/" className="breadcrumb-link">Home</Link>
          <span className="breadcrumb-separator">/</span>
          <Link to={`/products/${category}`} className="breadcrumb-link">
            {categoryData?.name || 'Products'}
          </Link>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">{product.name}</span>
        </div>
      </div>

      {/* Product Content */}
      <div className="product-detail-container">
        <div className="product-detail-grid">
          {/* Product Image */}
          <div className="product-detail-image-section">
            <div className="product-detail-image-wrapper">
              <img 
                src={product.image} 
                alt={product.name}
                className="product-detail-image"
              />
            </div>
          </div>

          {/* Product Information */}
          <div className="product-detail-info-section">
            <h1 className="product-detail-title">{product.name}</h1>
            
            <div className="product-detail-category">
              <span className="category-badge">{categoryData?.name}</span>
            </div>

            {/* Description */}
            {product.description && (
              <div className="product-detail-description">
                <p className="product-description-text">{product.description}</p>
              </div>
            )}

            {/* Overview */}
            {product.overview && (
              <div className="product-detail-overview">
                <h2 className="overview-title">Overview</h2>
                <p className="overview-text">{product.overview}</p>
              </div>
            )}

            {/* Specifications */}
            {product.specifications && product.specifications.length > 0 && (
              <div className="product-specifications">
                <h2 className="specifications-title">Specifications</h2>
                <div className="specifications-table">
                  {product.specifications.map((spec, index) => (
                    <div key={index} className="specification-row">
                      <span className="spec-label">{spec.label}:</span>
                      <span className="spec-value">{spec.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Export Note */}
            {product.exportNote && (
              <div className="product-export-note">
                <p className="export-note-text">
                  <strong>Export Focus:</strong> {product.exportNote}
                </p>
              </div>
            )}

            <div className="product-actions">
              <Link 
                to={`/products/${category}`}
                className="btn-secondary"
              >
                ← Back to {categoryData?.name}
              </Link>
              <button 
                className="btn-primary" 
                onClick={() => {
                  navigate('/contact', { 
                    state: { product: product.name } 
                  });
                  window.scrollTo(0, 0);
                }}
              >
                Contact for Inquiry
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
